import axios from 'axios'
import { dictionary } from '../../api'

const apiUrl = dictionary

export function loadDictionary(pageLimit, page, search) {
  return axios.get(`${apiUrl}/dictionary/filter?limit=${pageLimit}&offset=${page}&search=${search}`)
}

export function loadDictionaryById(id) {
  return axios.get(`${apiUrl}/dictionary/details/${id}`);
}

export function updateDictionary(id, data) {
  return axios.put(`${apiUrl}/dictionary/details/${id}`, data);
}

export function loadAllDictionary() {
  return axios.get(`${apiUrl}/dictionary/filter`)
}

export function loadDictionaryData(pageLimit, page, search, id) {
  return axios.get(`${apiUrl}/dictionary/item/parent?limit=${pageLimit}&offset=${page}&dictionary__id=${id}&search=${search}`)
}

// Load dictionary items whose parent is `parentId` (sub-categories,
// e.g. School -> Primary/Secondary). Returns [] when a type has no sub-types.
export function loadDictionaryByParent(parentId) {
  return axios.get(`${apiUrl}/dictionary/item/parent/data?limit=100&offset=0&dictionary_item_parent=${parentId}&search=`)
}

export function loadDictionaryItem(pageLimit, page, search) {
  return axios.get(`${apiUrl}/dictionary/item/filter?limit=${pageLimit}&offset=${page}&search=${search}`)
}

export function uploadDictionary(file) {
  return axios.post(`${apiUrl}/dictionary/upload`, file)
}

export function uploadDictionaryItem(file) {
  return axios.post(`${apiUrl}/dictionary/item/upload`, file)
}

export function addDictionary(data) {
  return axios.post(`${apiUrl}/dictionary`, data)
}

export function addDictionaryItem(data) {
  return axios.post(`${apiUrl}/dictionary/item`, data)
}

export function loadDictionaryItemById(id) {
  return axios.get(`${apiUrl}/dictionary/item/details/${id}`);
}

export function saveDictionaryItemChanges(id, data) {
  return axios.put(`${apiUrl}/dictionary/item/details/${id}`, data);
}

export function deleteDictionary(id) {
  return axios.delete(`${apiUrl}/dictionary/details/${id}`);
}

export function deleteDictionaryItem(id) {
  return axios.delete(`${apiUrl}/dictionary/item/details/${id}`);
}
